import { render } from "./VarslingFormComponent.vue?vue&type=template&id=1e491870"
import script from "./VarslingFormComponent.vue?vue&type=script&lang=js"
export * from "./VarslingFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/varsling/VarslingFormComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e491870"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e491870', __exports__)) {
    console.log('reload')
    api.reload('1e491870', __exports__)
  }
  
  module.hot.accept("./VarslingFormComponent.vue?vue&type=template&id=1e491870", () => {
    console.log('re-render')
    api.rerender('1e491870', render)
  })

}


export default __exports__